import React from 'react'
import PhoneInput from 'react-phone-input-2'

export default function PhoneInputPage(props) {
  return (
        <PhoneInput
            country={props?.country}
            enableSearch={props?.enableSearch}
            value={props?.value}
            className={props?.className}
            onChange={props?.onChange}
        />
  )
}
